import type { ReactNode } from "react";
import "./OperationalDirectory.css";

export type OperationalQueryStateProps = {
  hasData: boolean;
  isLoading: boolean;
  isFetching: boolean;
  error: unknown;
  isFiltered: boolean;
  onRetry: () => void;
  renderSkeleton: () => ReactNode;
  renderEmpty: (state: { filtered: boolean }) => ReactNode;
  children: ReactNode;
};

function RetryAlert({
  state,
  onRetry,
}: {
  state: "initial-error" | "refetch-error";
  onRetry: () => void;
}) {
  return (
    <div
      role="alert"
      data-state={state}
      className={`operational-query-state__error operational-query-state__error--${state}`}
    >
      <span>
        {state === "initial-error"
          ? "Não foi possível carregar."
          : "Não foi possível atualizar."}
      </span>
      <button type="button" onClick={onRetry}>
        Tentar novamente
      </button>
    </div>
  );
}

export function OperationalQueryState({
  hasData,
  isLoading,
  isFetching,
  error,
  isFiltered,
  onRetry,
  renderSkeleton,
  renderEmpty,
  children,
}: OperationalQueryStateProps) {
  if (!hasData && isLoading) return renderSkeleton();

  if (!hasData && error) {
    return (
      <div className="operational-query-state">
        <RetryAlert state="initial-error" onRetry={onRetry} />
      </div>
    );
  }

  if (!hasData) return renderEmpty({ filtered: isFiltered });

  return (
    <div
      className="operational-query-state"
      data-testid="operational-query-content"
      aria-busy={isFetching}
    >
      {error && <RetryAlert state="refetch-error" onRetry={onRetry} />}
      {children}
    </div>
  );
}
